( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-logo-carousel', {
			direction: 'horizontal',
			slidesPerView: 'auto',
			spaceBetween: 64,
			speed: 8000,
			autoplay: {
				delay: 0,
			},
			loop: true,
			grabCursor: true,

			breakpoints: {
				640: {
					spaceBetween: 80,
				},
				768: {
					spaceBetween: 96,
				},
				1024: {
					spaceBetween: 128,
				}
			},

			on: {
				touchStart: function() {
					this.autoplay.stop();
				},
				touchEnd: function() {
					this.autoplay.start();
				}
			}
		});
	} );
} )( jQuery, document, window );
